interface ITriggerContact {
  externalId: string;
  name: string;
  Email: boolean;
  Sms: boolean;
  Mobile: boolean;
}

export class TriggerContact implements ITriggerContact {
  externalId: string;
  name: string;
  Email: boolean;
  Sms: boolean;
  Mobile: boolean;

  public Create(externalId: string, name: string): TriggerContact {
    this.externalId = externalId;
    this.name = name;
    this.Email = true;
    this.Sms = true;
    this.Mobile = true;
    return this;
  }
}
